import api from './api';

const QuoteService = {
    list: (params) => api.get('/quotes', { params, paramsSerializer: { indexes: null } }).then(r => r.data),
    stats: () => api.get('/quotes/stats').then(r => r.data),
    get: (id) => api.get(`/quotes/${id}`).then(r => r.data),
    /** Unlock without the password; the server only allows it while the quote has no positions. */
    unlockEmpty: (id) => api.post(`/quotes/${id}/unlock-empty`).then(r => r.data),
    create: (payload) => api.post('/quotes', payload).then(r => r.data),
    update: (id, payload) => api.put(`/quotes/${id}`, payload).then(r => r.data),
    setStatus: (id, status) => api.patch(`/quotes/${id}/status`, { status }).then(r => r.data),
    remove: (id) => api.delete(`/quotes/${id}`),
    /** Accepted quote → jobs: [{ categoryId, itemIds, title, scheduledDate }]. Returns the quote with its jobs. */
    createJobs: (id, jobs) => api.post(`/quotes/${id}/jobs`, { jobs }).then(r => r.data),
    files: (id) => api.get(`/quotes/${id}/files`).then(r => r.data),
    uploadFile: (id, file, onProgress) => {
        const form = new FormData();
        form.append('file', file);
        return api.post(`/quotes/${id}/files`, form, {
            onUploadProgress: (e) => onProgress?.(e.total ? Math.round((e.loaded / e.total) * 100) : 0),
        }).then(r => r.data);
    },
    fetchFile: (id, fileId) => api.get(`/quotes/${id}/files/${fileId}`, { responseType: 'blob' }).then(r => r.data),
    deleteFile: (id, fileId) => api.delete(`/quotes/${id}/files/${fileId}`),
    // Positions; each call returns the whole quote with the new total.
    addItem: (id, payload) => api.post(`/quotes/${id}/items`, payload).then(r => r.data),
    updateItem: (id, itemId, payload) => api.put(`/quotes/${id}/items/${itemId}`, payload).then(r => r.data),
    deleteItem: (id, itemId) => api.delete(`/quotes/${id}/items/${itemId}`).then(r => r.data),
    moveItem: (id, itemId, direction) => api.post(`/quotes/${id}/items/${itemId}/move`, null, { params: { direction } }).then(r => r.data),
};

export default QuoteService;
